import React, {useEffect, useRef, useState} from 'react';
import Header from './Headers';
import Footer from '../footer';
import Swiper from 'react-id-swiper';
import Currentopening from './Currentopening';
import imagesPath from '../config/imagesPath';
import ReactGA from 'react-ga';
import {Helmet} from "react-helmet";

const Career = () => {
    const [isMobileView, setIsMobileView] = useState(null)


    const resize = () => {
        let currentHideNav = (window.innerWidth <= 767);
        if (currentHideNav !== isMobileView) {
            setIsMobileView(currentHideNav);
        }
    }
    useEffect(() => {
        window.addEventListener("resize", resize());
        return () => {
            window.removeEventListener("resize", resize());
        }
    }, [])


    const params = {
        loop: true,

        slidesPerView: 3,
        spaceBetween: 15,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        autoplay: {
            delay: 2000,
            pauseOnMouseEnter: true,
        },

        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 5
            },
            480: {
                slidesPerView: 1,
                spaceBetween: 15
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 15
            }
        }
    }
    const swiperRef = useRef(null)
    const banner = {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 15,
        // navigation: {
        // 	nextEl: '.swiper-button-next',
        // 	prevEl: '.swiper-button-prev'
        // },
        autoplay: {
            delay: 3000,
        },
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        ReactGA.initialize('UA-128486561-1');
        ReactGA.pageview('/career');
    }, [])

    return (
        <div>
            <Helmet>
                <meta name="title" content="Revfin is a great place to work"/>
                <meta name="description"
                      content="Revfin team consists of hard working and ambitious people who bring a lot of positive energy to the team."/>
            </Helmet>
            <Header/>
            <div className="homesliders" style={{
                top: '0px',
                left: '0px',
                width: '100%',
                height: '500px',
                backgroundColor: '#1e3056',
            }}>
                <Swiper {...banner}>
                    {

                        imagesPath.bannerImage.map((ele, index) => (
                            <div style={{
                                top: '-24px',
                                position: 'relative',
                            }}>
                                <img src={ele.img} alt='' className='career-banner'/>
                            </div>
                        ))
                    }

                </Swiper>

            </div>
            <div className='container'>
                <div className="careers-hb__container__header" data-aos="fade-out">
                    <div className="careers-hb-container" data-aos="fade-up">
                        <h1>Life @ Revfin</h1>
                        <p className="xs-hidden" data-aos="fade-left">Building India’s largest lending company.
                            <br/>Through our award winning and innovative digital platform,<br/> we provide loans to
                            people at the bottom of the pyramid.</p>
                        <p className="xs-visible" data-aos="fade-right">The teams at Revfin solve problems of growth,
                            complexity, scale and design every day.</p>
                        <a className="careers-btn-container" href="#cards" data-aos="fade-down">
                            <button className="careers-btn-container__btn">See current openings</button>
                        </a>
                    </div>
                </div>
            </div>
            {isMobileView ? (<section id="services">
                <div className="container " data-aos="fade-up">

                    <div className="cara_slider newAdditon">
                        <Swiper {...params}>
                            {
                                imagesPath.gridImages.map((ele, index) => (
                                    <img src={ele.img} alt="" className='grid-img-style' key={index}/>
                                ))
                            }
                        </Swiper>
                    </div>
                    <div className="full-width-container">
                        <div className="content">
                            <div className="group-photo-border-line-1"></div>
                            <div className="group-photo-border-line-2"></div>
                        </div>
                    </div>
                </div>
            </section>) : (<section id="services" className=" career-title">
                <div className="container" data-aos="fade-up">
                    <div className="contt">
                        <div className='row_1'>
                            <div className='cont image-of-grid-1'><img src={imagesPath.gridImages[0].img} alt=""/></div>
                            <div className='cont image-of-grid-2'><img src={imagesPath.gridImages[1].img} alt=""/></div>
                        </div>
                        <div className='row_2 image-of-grid-3'><img src={imagesPath.gridImages[2].img} alt=""/></div>
                        <div className='row_3'>
                            <div className='cont image-of-grid-4'><img src={imagesPath.gridImages[3].img} alt=""/></div>
                            <div className='cont image-of-grid-5'><img src={imagesPath.gridImages[4].img} alt=""/></div>
                        </div>
                    </div>
                </div>
            </section>)
            }

            <section id="services" className="services career-title">
                <div className="container" data-aos="fade-up">
                    <p className='values-at-revfin-p'>We’re building the foundation of our team right now and are
                        looking for ambitious team members to join us and grow rapidly with us. The work environment is
                        fast-paced, and you would make a clear impact!
                        We’re a well-funded start-up, which has raised capital from organization like Shell
                        Foundation. </p>
                </div>
            </section>

            <section id="services" className="team-talk ">
                <div className="container " data-aos="fade-up">
                    <div className="section-titles">
                        <h3 className="heading_tow">Team Talk</h3>
                    </div>
                    <div className="cara_slider newAdditon"
                         onMouseEnter={() => swiperRef.current.swiper.autoplay.stop()}
                         onMouseLeave={() => swiperRef.current.swiper.autoplay.start()}>
                        <Swiper {...params}
                                ref={swiperRef}>
                            {
                                imagesPath.team_talk.map((ele, index) => (
                                    <iframe height={300} className="testimonial-width"
                                            id='player'
                                            type='text/html'
                                            src={ele.video}
                                            key={index}
                                            title="YouTube video player" frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen style={{
                                        height: "250px",
                                    }}>
                                    </iframe>
                                ))
                            }
                        </Swiper>
                    </div>
                </div>
            </section>
            <Currentopening/>
            <Footer/>
        </div>
    )
}

export default Career;



// WEBPACK FOOTER //
// ./src/components/Career.js